import { DialogDescription } from "design-system/dialog";
import type { ReactNode } from "react";
import { StepHeader } from "./step-header";

// Flow-local error screen: a specific, non-scary message plus a support contact and caller-supplied actions.
// Shared across this flow's error states (e.g. the org already has a wallet, or provider sync failed).
export function AuthErrorView({
  actions,
  description,
  testId,
  title,
}: {
  actions?: ReactNode;
  description: ReactNode;
  testId?: string;
  title: string;
}) {
  return (
    <>
      <StepHeader secured={false} title={title} />
      <DialogDescription className="text-neutral-600" data-testid={testId}>
        {description}
      </DialogDescription>
      <p className="text-sm text-neutral-600">
        {"Need help? Contact "}
        <a className="underline" href="mailto:support@agora.finance">
          support@agora.finance
        </a>
        .
      </p>
      {actions}
    </>
  );
}
